<template>
  <div class="box-date my-2">
    <div class="date">
      <strong>ວັນທີ {{ date }}</strong>
    </div>
    <div class="box">
      <div class="row no-gutters">
        <div class="col-md-6 sec-1">
          <div class="p-1">
            <div class="text-center">
              <strong>ຕອນເຊົ້າ</strong>
            </div>
            <div class="row no-gutters" :class="[{'up': isUp('sec1')}, {'down': isDown('sec1')}]">
              <div class="col">
                <div class="text-center text-header">ດັດຊະນີ</div>
                <div class="price" :class="price('sec1')?'text-right':'text-center'">{{ price('sec1') | amountFormat(2, '-') }}</div>
              </div>
              <div class="col">
                <div class="text-center text-header">ປ່ຽນແປງ</div>
                <div class="text-right price fix-w110"><i class="fas" :class="[{'fa-caret-up': isUp('sec1')}, {'fa-caret-down': isDown('sec1')}]"></i> {{ diff('sec1') | amountFormat(2, '') }}({{ per('sec1') | amountFormat(2, '') }}%)</div>
              </div>
              <div class="col">
                <div class="text-center text-header">ປະລິມານ</div>
                <div class="text-right">{{ volume('sec1') | amountFormat(2, '') }}</div>
              </div>
              <div class="col">
                <div class="text-center text-header">ມູນຄ່າ</div>
                <div class="text-right">{{ value('sec1') | amountFormat(2, '') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 sec-2" v-if="price('sec2')">
          <div class="p-1">
            <div class="text-center">
              <strong>ຕອນບ່າຍ</strong>
            </div>
            <div class="row no-gutters" :class="[{'up': isUp('sec2')}, {'down': isDown('sec2')}]">
              <div class="col">
                <div class="text-center text-header">ດັດຊະນີ</div>
                <div class="price" :class="price('sec2')?'text-right':'text-center'">{{ price('sec2') | amountFormat(2, '') }}</div>
              </div>
              <div class="col">
                <div class="text-center text-header">ປ່ຽນແປງ</div>
                <div class="text-right price fix-w110"><i class="fas" :class="[{'fa-caret-up': isUp('sec2')}, {'fa-caret-down': isDown('sec2')}]"></i> {{ diff('sec2') | amountFormat(2, '') }}({{ per('sec2') | amountFormat(2, '') }}%)</div>
              </div>
              <div class="col">
                <div class="text-center text-header">ປະລິມານ</div>
                <div class="text-right">{{ volume('sec2') | amountFormat(2, '') }}</div>
              </div>
              <div class="col">
                <div class="text-center text-header">ມູນຄ່າ</div>
                <div class="text-right">{{ value('sec2') | amountFormat(2, '') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from '@/moment'

export default {
  name: 'BoxHistory',
  props: ['data'],
  computed: {
    date() {
      return moment(this.data.date).format("DD MMM YYYY")
    }
  },
  methods: {
    price(sec) {
      return this.data?.[sec]?.price
    },
    diff(sec) {
      return this.data?.[sec]?.diff
    },
    per(sec) {
      return this.data?.[sec]?.per
    },
    volume(sec) {
      return this.data?.[sec]?.volume
    },
    value(sec) {
      return this.data?.[sec]?.value
    },
    isUp(sec) {
      return (this.data?.[sec]?.diff || 0) > 0
    },
    isDown(sec) {
      return (this.data?.[sec]?.diff || 0) < 0
    }
  }
}
</script>
<style lang="scss" scoped>
.box-date {
  .date {
    color: #004998;
  }
  .box {
    border: 1px solid #004998;
    border-radius: 4px;

    .up {
      .price, .fas {
        color: green;
      }
    }

    .down {
      .price, .fas {
        color: red;
      }
    }

    .sec-1 {
      background-color: rgba(0,73,152,0.2);
    }

    .sec-2 {
      background-color: rgba(0,73,152,0.1);
    }

    .text-header {
      color: #004998;
    }
  }
}

@media only screen and (max-width:991px) {
  .box-date {
    .box {
      .col-md-6 {
        .row {
          justify-content: space-between;

          .col {
            flex-grow: unset;

            .fix-w110 {
              width: 110px;
            }
          }
        }
      }
    }
  }
}
</style>
